















































import { Component, Vue } from "vue-property-decorator";
import { IContent } from "@/models/Content.model";
@Component
export default class AboutForm extends Vue {
  get about() {
    return this.$store.getters.getAboutContent;
  }
  content: IContent = {};
  fixedString = "";
  update() {
    if (this.content.text) {
      this.fixedString = this.content.text.replace(/(?:\r\n|\r|\n)/g, "<br>");
    }
    this.content.text = this.fixedString;
    this.$emit("update", this.content);
  }

  mounted() {
    this.content = Object.assign({}, this.about);
  }

  cancel() {
    this.content = Object.assign({}, this.about);
  }
}
